import { ClassAssignmentStatus } from './class-assignment.model';

export const ASSIGNMENT_SLUG_PARAM = 'assignmentSlug';

/** Canonical string values for {@link ClassAssignmentStatus} (safe for comparisons & templates). */
export const CLASS_ASSIGNMENT_STATUS: Record<ClassAssignmentStatus, ClassAssignmentStatus> = {
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  PUBLISHED: 'PUBLISHED',
};

export const STATUS_LABELS: Record<ClassAssignmentStatus, string> = {
  DRAFT: 'assignments.status.draft',
  SCHEDULED: 'assignments.status.scheduled',
  PUBLISHED: 'assignments.status.published',
};

export const STATUS_COLOR_CLASSES: Record<ClassAssignmentStatus, string> = {
  DRAFT: 'bg-neutral-100 text-neutral-600',
  SCHEDULED: 'bg-orange-100 text-orange-600',
  PUBLISHED: 'bg-sky-100 text-sky-600',
};

export const STATUS_OPTIONS: Array<{ value: ClassAssignmentStatus; labelKey: string }> = (
  Object.keys(STATUS_LABELS) as ClassAssignmentStatus[]
).map((status) => ({
  value: status,
  labelKey: STATUS_LABELS[status],
}));
